import React, { useEffect, useState } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import Router from "@routes/Router";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@libs/reactQuery/queryClient";
import { ThemeProvider } from "@emotion/react";
import { dark, light } from "./theme";
import styled from "@emotion/styled";
import i18n from "i18next";

const Container = styled.div(() => ({
  display: "flex",
  justifyContent: "center",
  height: "100%",
  backgroundColor: "#DEE5D4",
}));

const AppWrapper = styled.div({
  position: "relative",
  display: "flex",
  maxWidth: "560px",
  justifyContent: "center",
  height: "100%",
  backgroundColor: "#ffffff",

  "::-webkit-scrollbar": {
    display: "none",
  },
});

function App() {
  const [themeMode] = useState("light");

  useEffect(() => {
    if (window.localStorage.getItem("language") === null) {
      window.localStorage.setItem("language", "ko");
      i18n.changeLanguage("ko");
    } else {
      i18n.changeLanguage(window.localStorage.getItem("language") as string);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} position="bottom" />

      <ThemeProvider theme={themeMode === "light" ? light : dark}>
        <Container>
          <AppWrapper>
            <Router />
          </AppWrapper>
        </Container>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
